import React from 'react'
import CanvasJSReact from '@canvasjs/react-charts';



var CanvasJSChart = CanvasJSReact.CanvasJSChart;
export const ChartAdd2 = ({ bidWonAmount, investedBiddingAmount }) => {



    const options = {
        animationEnabled: true,
        useHTML: true,
        subtitles: [{
            
            verticalAlign: "center",
            fontSize: 24,

        }],
  
        data: [{
            type: "doughnut",
            innerRadius: "80%",
            yValueFormatString: "#,###'%'",
            dataPoints: [
                { y: investedBiddingAmount, color: "#F9C114" },
                { y: bidWonAmount, color: "#043BC7" },
            ]

        }],

    

    }
    
 

    return (

        <div >
            <CanvasJSChart options={options} />

        </div>
    )
}

